// The production entry point (design DD1; session-handoff task 7.1, re-shaped by rounds-slice
// implementation-review **F1**): find `#root` and hand it to the bootstrap.
//
// Everything that used to live here — the production dependency set, and now the **mode fork**
// between the live root (`App` → `SessionController` → `/ws`) and the rounds root (`RoundsApp` →
// `RoundsController` → `rounds-http`) — moved into `app/bootstrap.tsx` so it is testable. F1's
// finding was precisely that this file's composition had no test: `bootstrap.rounds.test.tsx` now
// drives the real `Bootstrap` with no injected route props, which this file's three lines cannot
// diverge from.
//
// `import.meta.env.VITE_GAME_MODE` and `window.location.search` are read here because they are
// environment, not logic: the bootstrap takes them as values so a test can supply its own.

import { mountApp } from './app/bootstrap';
import './ui/tokens/index.css';
// App-shell root-height chain (D-085): establishes `html,body,#root { height:100% }` so the Match
// screen's `height:100%` field-canvas chain resolves to the viewport instead of collapsing to zero.
// Kept out of the token mirror (`index.css`) — see app-shell.css.
import './ui/app-shell.css';

const root = document.getElementById('root');

if (root === null) {
  throw new Error('missing #root element');
}

mountApp(root, {
  pathname: window.location.pathname,
  search: window.location.search,
  configuredMode: import.meta.env.VITE_GAME_MODE as string | undefined,
});
